module.exports = __webpack_public_path__ + "static/media/02-07.1f4a28cc.png";